import { MKT } from 'src/sections/@dashboard/marketing/marketing.design';

// status/plataforma agora vem de StatusChip/PlatformChip (fontes unicas
// compartilhadas) — os mapas antigos `statusBadge`/`platformBadge` saem daqui.
export const MKT_METRICAS_DESIGN = {
    ...MKT,
    page: {
        ...MKT.page,
        root: 'flex flex-col min-h-full w-full bg-[#f4f4f7] text-[#18181b] animate-in fade-in slide-in-from-bottom-4 duration-500',
        fontStack: "'Plus Jakarta Sans', Manrope, ui-sans-serif, system-ui, sans-serif",
        container: 'w-full px-4 md:px-6 lg:px-8',
        pageBody: 'pb-[120px]',
        stickyHeader: 'sticky top-0 z-30 bg-white border-b border-[#e7e7ec]',
        topbar: 'flex flex-col md:flex-row md:items-start gap-4 pt-[18px] pb-[18px]',
        topbarIdentity: 'flex items-start gap-3.5 min-w-0 flex-1',
        iconTile:
            'flex items-center justify-center flex-shrink-0 w-[42px] h-[42px] rounded-[10px] bg-[#ede9fe] text-[#6d28d9]',
        headerTitle: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b] truncate',
        headerSubtitle: 'mt-[5px] text-[13px] text-[#71717a] leading-[1.5]',
        topbarActions: 'flex items-center gap-2 flex-shrink-0 flex-wrap md:pt-[5px]',
        backButton:
            'flex items-center justify-center flex-shrink-0 w-[34px] h-[34px] mt-[3px] rounded-lg bg-transparent text-[#71717a] transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b]',
        metaBar: 'flex flex-wrap items-center gap-x-6 gap-y-3 mb-5',
    },
    header: {
        ...MKT.header,
        metaItem: 'flex items-center gap-2.5',
        metaIconBox: 'w-8 h-8 rounded-lg bg-[#f4f4f5] flex items-center justify-center flex-shrink-0',
        metaLabel: 'text-[10px] font-semibold text-[#a1a1aa] uppercase tracking-wider',
        metaValue: 'text-[13px] font-semibold text-[#18181b]',
        keywordsWrap: 'flex flex-wrap items-center gap-1.5 mb-6',
        keywordsLabel: 'text-xs font-semibold text-[#71717a] uppercase tracking-wider mr-1',
        keywordChip: 'px-2.5 py-1 rounded-full text-xs font-medium bg-[#ede9fe] text-[#5b21b6] border border-[#ddd6fe] whitespace-nowrap',
        keywordChipMore: 'px-2.5 py-1 rounded-full text-xs font-medium bg-[#f4f4f5] text-[#71717a] border border-[#e7e7ec] whitespace-nowrap',
    },
    section: {
        wrapper: `${MKT.surface.card} p-6 mb-6`,
        headerRow: 'flex items-center justify-between mb-6 flex-wrap gap-3',
        title: 'text-lg font-bold text-foreground',
        // KPIs sem ícone ficam melhor em faixa cheia; tabela geo abaixo.
        metricsGrid: 'grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6',
    },
    table: {
        ...MKT.table,
        card: 'border-0 bg-card shadow-sm rounded-xl',
        headCell: 'text-muted-foreground font-semibold sticky top-0 z-10 bg-card',
        row: 'hover:bg-accent/50 transition-colors',
        progressTrack: 'w-20 bg-muted rounded-full h-2.5 overflow-hidden',
        progressFill: 'h-full rounded-full transition-all duration-500',
    },
    // Secao "Leads por anuncio" (captura Click-to-WhatsApp).
    ctwa: {
        // 3 cards em largura cheia: `stats.grid` e de 4 colunas e deixaria um
        // buraco no fim da linha.
        grid: 'grid grid-cols-1 md:grid-cols-3 gap-3 mb-6',
        subtitle: 'text-xs text-muted-foreground mt-1.5',
        // Banner de status da varredura retroativa — a cor vem de `tone[...]`
        // (TONE compartilhado, ja espalhado em `d.tone`), este token so cuida
        // do layout do banner em si.
        banner: 'flex items-center gap-2.5 rounded-xl border p-3 mb-4 text-sm font-medium',
        rank: 'w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold text-white shadow-sm',
        adName: 'font-semibold text-foreground',
        // O ad id da Meta e uma sequencia numerica longa: mono deixa os ids
        // comparaveis na vertical e o truncate segura a largura da coluna.
        adId: 'text-xs text-muted-foreground font-mono truncate max-w-[220px]',
        // Coluna de anuncio dentro da tabela de chats capturados — nome de
        // anuncio da Meta e longo demais pra caber sem corte.
        chatAd: 'block max-w-[200px] truncate text-sm text-foreground',
        leadsValue: 'text-sm font-bold text-foreground tabular-nums w-10 text-right',
    },
    crm: {
        wrapper: `${MKT.surface.card} mb-6 p-4`,
    },
    chatsTable: {
        wrapper: `${MKT.surface.card} p-6 mb-8`,
    },
    exportBtn: 'flex items-center gap-2',
};
